import { subtaskStatusLabel, isOpenSubtask } from '../../helpers/adressHelpers/subtasksPerAdress.js';

/**
 * De subtaken van deze afspraak als lijstje onder de details.
 *
 * WAAROM ALLEEN LEZEN: aanpassen gebeurt op het tabblad 'Subtaken'. Twee
 * schermen die hetzelfde document schrijven lopen uiteen zodra er aan één kant
 * iets verandert; dit lijstje beantwoordt alleen de vraag 'wat ligt er nog'.
 *
 * Updateverzoek BuurtKlusBedrijf: 'de subtaken staan nu niet bij de details, we
 * willen ze daar als lijstje terugzien'.
 *
 * Staat er niets, dan staat er ook NIETS: een kopje 'Subtaken' met een
 * streepje eronder maakt elk detailscherm langer zonder iets te vertellen, en
 * de meeste afspraken hebben geen subtaken.
 *
 * @param {object} props
 * @param {Array<object>|string} [props.subTasks] - De subtaken van deze afspraak; '' zolang ze nog niet binnen zijn
 * @returns {JSX.Element|null}
 */
const TaskSubtaskSummary = ({ subTasks }) => {
    // `''` is de 'nog niet geladen'-waarde van de engine. Tijdens het laden
    // niets tonen is hier juist: de rest van het detailscherm staat er al, en
    // een regel 'geen subtaken' die daarna omslaat leest als een fout.
    if (!Array.isArray(subTasks) || subTasks.length === 0) return null;

    const open = subTasks.filter(isOpenSubtask).length;

    return (
        <div className="task-editor-subtask-summary">
            <span className="task-editor-field-label">
                Subtaken
                {' '}
                <span className="task-editor-subtask-summary__count">
                    {open === 0 ? 'alles klaar' : `${open} van de ${subTasks.length} te doen`}
                </span>
            </span>
            <ul className="task-editor-subtask-summary__list">
                {subTasks.map((sub) => (
                    <li
                        key={sub.ID || sub.docid}
                        className={`task-editor-subtask-summary__item${isOpenSubtask(sub) ? '' : ' task-editor-subtask-summary__item--done'}`}
                    >
                        <span className="task-editor-subtask-summary__title">{sub.Title || 'Naamloze taak'}</span>
                        <span className="task-editor-subtask-summary__status">{subtaskStatusLabel(sub)}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TaskSubtaskSummary;
